import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_2 = {
  key: 1,
  class: "indication-progress"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_popper = _resolveComponent("popper")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    body: _ctx.body,
    header: _ctx.header,
    appearance: _ctx.appearance,
    config: _ctx.tableConfig
  }, {
    options: _withCtx(() => [
      _renderSlot(_ctx.$slots, "options")
    ]),
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "actions", {}, () => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_popper, {
            class: "dark-popper",
            arrow: "",
            hover: "",
            placement: "top",
            content: "Ver"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-danger p-0 w-30px h-30px",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDocument && _ctx.openDocument(...args)))
              }, [
                (!_ctx.showProgress)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "eye",
                      class: "indicator-label"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 3
  }, 8, ["body", "header", "appearance", "config"]))
}